import React, { useState, useEffect, useRef } from 'react'

import {
  Button,
  Row,
  Col,
  FormGroup,
  Input,
  Badge,
  Alert,
  Table,
} from 'reactstrap'
import { connect } from 'react-redux'
import { Async } from 'react-select'
import moment from 'moment'
import axios from '../../../../axios'
import * as url from '../../../../utils/url'
import * as actionCreators from '../../../../modules/actions/index'
import Loading from '../../../../hoc/Loading/Loading'
import { AiFillCloseCircle } from 'react-icons/ai'
import { MdFileUpload, MdOutlineMobileFriendly } from 'react-icons/md'
import { FaArrowRight } from 'react-icons/fa6'
import Select from 'react-select'
import { SURVEY_QUESTIONS } from '../../../../components/Survey/data'
import { IoCloudUploadOutline } from 'react-icons/io5'
import PhoneInputWithCountrySelect from 'react-phone-number-input'
import Papa from 'papaparse'

import {
  BiCaretDown,
  BiCaretUp,
  BiEditAlt,
  BiMailSend,
  BiPlusCircle,
  BiTrashAlt,
  BiX,
  BiXCircle,
} from 'react-icons/bi'
import { BsCheck2Circle, BsThreeDots } from 'react-icons/bs'
import {
  formatPhoneNumber,
  generateRandomString,
  isUrlValid,
  profilePicValidityCheck,
  removeDuplicates,
  trivvyFileTypeCheck,
  uploadPreview,
} from '../../../../utils/constants'

import CheckBox from 'rc-checkbox'
import ReactTooltip from 'react-tooltip'
import {
  ActionLayoutData,
  ActionLayoutHeading,
  LayoutHeading,
  LayoutRow,
  LayoutData,
} from "../../../../pages/weekly-wins/TableLayoutComponents";
import { isMobile } from "../../../../utils/deviceInfo";
import MapColumnStep from "./MapColumnStep";
import { toastContainer } from "../../../../utils/toast";

export default function ShareHandlingForMessagingTrivvys({
  user,
  setSmsUsers,
}) {
  const isOwner = false
  const [allUsersChecked, setAllUsersChecked] = useState(false)
  const [step, setStep] = useState(0)
  const [options, setOptions] = useState([])
  const [uploadCsvUiOpen, setUploadCsvUiOpen] = useState(false)
  const [invalidUsersList, setInvalidUsersList] = useState([])
  const [showInvalidUsers, setShowInvalidUsers] = useState(false)
  const [usersListAll, setUsersListAll] = useState([])
  const [usersList, setUsersList] = useState([])
  const [usersData, setUsersData] = useState([])
  const [rowData, setRowData] = useState([])
  const [usersLodaing, setUsersLoading] = useState(false)
  const [duplicateUsers, setDuplicateusers] = useState([])
  const [newUserRows, setNewUserRows] = useState([
    { name: '', mobileNumber: '' },
  ])
  const [showDuplicateEntries, setShowDuplicateEntries] = useState(false)

  const [triviaShareAndPrivacy, setTriviaShareAndPrivacy] = useState({
    sharedWithUsers: [],
    privacy: 'PUBLIC',
  })
  const [editingIndex, setEditingIndex] = useState(null)

  const [file, setFile] = useState(null)

  const handleFileUpload = (e) => {
    const csvFile = e.target.files[0]

    setFile(csvFile)
    Papa.parse(csvFile, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: 'greedy',
      complete: handleCsvParseComplete,
    })
  }

  const handleCsvParseComplete = (result, file) => {
    const fields = result.meta.fields
    const data = result.data

    const newData = []

    for (const field of fields) {
      newData.push({
        selectedKey: '',
        fieldName: field,
        data: [],
      })
    }

    console.log('fields---', fields)
    if (fields.indexOf('phone') > -1) {
    }

    for (const item of data) {
      for (const field of fields) {
        const indx = newData.findIndex((x) => x.fieldName == field)
        if (indx >= 0) {
          const dataToAdd = item[field] ? item[field].toString() : ''
          newData[indx].data.push(dataToAdd)
        } else {
          console.log('no fielddd')
        }
      }
    }

    setRowData(newData)
    setUploadCsvUiOpen(true)
    setStep(1)
  }

  useEffect(() => {
    setSmsUsers(triviaShareAndPrivacy.sharedWithUsers)
  }, [triviaShareAndPrivacy.sharedWithUsers])

  useEffect(() => {
    setUsersLoading(true)
    axios
      .get(url.userListArray)
      .then((response) => {
        setUsersLoading(false)
        const finalUsers = response.data.data.filter((x) => x.mobileNumber)
        setUsersData(finalUsers)
        const users = formatSelectedUsers(finalUsers)
        setUsersListAll(formatSelectedUsers(response.data.data))
        setUsersList(users)
        setOptions(users)
      })
      .catch((error) => {
        setUsersLoading(false)
        console.log(error)
      })
  }, [])

  const tableCols = {
    user: 6,
    action: 2,
    phoneNumber: 4,
  }

  const removeDuplicatesUsersByEmailAndMobileNumber = (arr) => {
    const emails = new Set()
    const phoneNumbers = new Set()
    const duplicatesArray = []

    console.log('new-arr', arr, arr.length)

    const filtered = arr.filter((item) => {
      const { email, mobileNumber } = item
      if (
        (email && emails.has(email)) ||
        (mobileNumber && phoneNumbers.has(mobileNumber))
      ) {
        console.log(
          'DUPP',
          { email, mobileNumber, emails, phoneNumbers },
          email && emails.has(email),
          mobileNumber && phoneNumbers.has(mobileNumber)
        )
        duplicatesArray.push(item)
        return false // exclude duplicates (either email or phoneNumber is already seen)
      } else {
        console.log(
          'NO_DUPP',
          { email, mobileNumber, emails, phoneNumbers },
          email && emails.has(email),
          mobileNumber && phoneNumbers.has(mobileNumber)
        )
        if (email) {
          emails.add(email) // add email to the Set
        }
        if (mobileNumber) {
          phoneNumbers.add(mobileNumber) // add phoneNumber to the Set
        }

        return true // include unique item
      }
    })

    setDuplicateusers(duplicatesArray)
    emails.clear()
    phoneNumbers.clear()
    return filtered
  }

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e._id || e.userId) {
        return {
          label: `${e.firstName || ''}, ${e.lastName || ''} (${
            e.mobileNumber
          })`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName: e.firstName,
          lastName: e.lastName,
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
        }
      }
    })

    return d
  }

  const onUserSelect = (u) => {
    const array = [u, ...triviaShareAndPrivacy.sharedWithUsers]
    if (u) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber(array),
      })
    }
  }

  const originalOptions = usersList.filter(
    (x) =>
      !triviaShareAndPrivacy.sharedWithUsers.some((y) => y.value == x.value)
  )

  const removeUser = (id, mobileNumber) => {
    const users = [...triviaShareAndPrivacy.sharedWithUsers]

    const newUsers = users.filter((x) => x.value != id)

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber([
        ...newUsers,
      ]),
    })

    // callApiToSaveData(newUsers, "REMOVE");
  }

  const onUserSelectAll = (u) => {
    if (u) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [
          ...triviaShareAndPrivacy.sharedWithUsers,
          ...usersList,
        ],
      })
    } else {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [],
      });
    }
  }

  const viewMember = (u) => {
    // let link = `/home/${user.profile.organizationId._id}/profile/${u.value}`;
    // props.history.push(link);
  }

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : 'N'
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";

      if(firstName =="N" && lastName == "N"){
        if(user.email){
          return user.email.charAt(0) + user.email.split('@')[1].charAt(0)
        }else{
          return;
        }
       
      }else{
        return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
      }
    
  };

  const handleNewUserRowChange = (value, key, index) => {
    const rows = [...newUserRows]
    rows[index][key] = value

    setNewUserRows(rows)
  }

  const addNewRowUserToShareTable = (index) => {
    const newUsersArr = [...newUserRows]

    const newUserObject = newUsersArr[0]

    const sharedUsers = []

    // const findInUsersList = usersList.find(x => x&&newUserObject&& x.mobileNumber == newUserObject.mobileNumber)

    // if(findInUsersList){
    //   toastContainer(`User with mobile number "(${newUserObject.mobileNumber})" already exists`)
    //   return
    // }

    const formatObject = {
      ...(newUserObject.name && {
        firstName: newUserObject.name.split(' ')[0],
        lastName: newUserObject.name.split(' ')[1],
      }),
      mobileNumber: newUserObject.mobileNumber,
    }

    sharedUsers.push(formatObject)

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber([
        ...triviaShareAndPrivacy.sharedWithUsers,
        ...sharedUsers,
      ]),
    })

    revertOptions()
  }

  const revertOptions = () => {
    setOptions(originalOptions)
    setNewUserRows([{ name: '', mobileNumber: '' }])
  }

  const { privacy, sharedWithUsers } = triviaShareAndPrivacy

  const isNewUser = (usr) => {
    const usersAll = [...usersListAll]

    if (usr.email || usr.mobileNumber) {
      const user = usersAll.find(
        (x) =>
          usr._id ||
          (usr.email &&
            x.email &&
            usr.email.trim().toLowerCase() === x.email.trim().toLowerCase()) ||
          (usr.mobileNumber &&
            x.mobileNumber &&
            usr.mobileNumber.trim() === x.mobileNumber.trim())
      )

      if (user) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  // Handle input change in react-select

  const newUser = newUserRows[0]

  const innerRef = useRef()
  const innerRef2 = useRef()

  const handleInputChange = (value) => {
    // Filter options based on input value
    const filteredOptions = originalOptions.filter((option) =>
      option.label.toLowerCase().includes(value.toLowerCase())
    )
    if (filteredOptions.length == 0) {
      if (isNaN(value)) {
        setNewUserRows([{ ...newUserRows[0], name: value }])
      } else {
        setNewUserRows([{ ...newUserRows[0], mobileNumber: value }])
      }
    }
    setOptions(filteredOptions)
  }
  useEffect(() => {
    const newR = newUserRows[0]

    if (newR) {
      if (newR.name) {
        if (innerRef && innerRef.current) {
          innerRef.current.focus()
        }
      }

      if (newR.mobileNumber) {
        if (innerRef2 && innerRef2.current) {
          innerRef2.current.focus()
        }
      }
    }
  }, [options.length])

  const handleChangeTableRowData = (index, key, value) => {
    const dataOld = [...triviaShareAndPrivacy.sharedWithUsers]
    dataOld[index][key] = value

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber(dataOld),
    })
  }

  return (
    <div>
      {duplicateUsers && duplicateUsers.length ? (
        <div>
          {' '}
          <Alert color={'danger'}>
            You have added duplicate entries,{' '}
            <b
              className="cursor-pointer"
              onClick={() => setShowDuplicateEntries(!showDuplicateEntries)}>
              Click here
            </b>{' '}
            to see
          </Alert>
          {showDuplicateEntries && (
            <div>
              <Table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile Number</th>
                  </tr>
                </thead>
                <tbody>
                  {duplicateUsers.map((dUser) => {
                    return (
                      <tr>
                        <td>
                          {dUser.firstName || ''} {dUser.lastName || ''}
                        </td>
                        <td>{dUser.email || ''}</td>
                        <td>{dUser.mobileNumber || ''}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      ) : (
        ''
      )}

      <div style={{ marginTop: '1em' }}>
        Select who to share this message with -{' '}
        {triviaShareAndPrivacy.sharedWithUsers &&
          triviaShareAndPrivacy.sharedWithUsers.length > 0 && (
            <span>
              {' '}
              shared with{' '}
              <b>{triviaShareAndPrivacy.sharedWithUsers.length} users</b>
            </span>
          )}{' '}
        <span></span>
        <div className="col-sm-12">
          <div className={`my-1 share-quiz-privacy`}>
            <FormGroup className="mt40 share-quiz-privacy-form-css" row>
              <Col sm={12} md={12} lg={12}>
                <span
                  className="enterprise-setting-label"
                  style={{
                    fontSize: '15px',
                    color: 'grey',
                    fontWeight: 400,
                  }}>
                  {allUsersChecked ? 'Remove' : 'Add'} all platform users{' '}
                </span>
                <CheckBox
                  checked={allUsersChecked}
                  onChange={(e) => {
                    setAllUsersChecked(!allUsersChecked)
                    onUserSelectAll(!allUsersChecked)
                  }}
                />
              </Col>

              <Col sm={12} md={12} lg={12}>
                <div
                  className="show_shared_trivvy_users"
                  style={{
                    overflow: 'hidden',
                  }}>
                  <div className="shareTableTrivia">
                    {!isMobile && (
                      <LayoutRow className="mobileNoheightActionTable">
                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.user}
                          plainTable>
                          User
                        </LayoutHeading>

                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.phoneNumber}
                          plainTable>
                          Mobile Number
                        </LayoutHeading>

                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.action}
                          plainTable>
                          Action
                        </LayoutHeading>
                      </LayoutRow>
                    )}

                    <div
                      style={{
                        maxHeight:
                          sharedWithUsers && sharedWithUsers.length > 0
                            ? '220px'
                            : '0px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        marginLeft: '-15px',
                      }}
                      className="hide-scroll w1scr">
                      {sharedWithUsers && sharedWithUsers.length > 0
                        ? sharedWithUsers.map((item, itemIndex) => {
                            const editMode = editingIndex === itemIndex
                            const showEditBtn = !(item.value || item._id)
                            if (isMobile) {
                              return (
                                <LayoutData
                                  fullWidth
                                  className="col-pl-0 d-block bg-white">
                                  <div
                                    style={{
                                      alignItems: 'center',
                                      display: 'flex',
                                    }}
                                    className="my-2 pl-2">
                                    {isNewUser(item) && (
                                      <Badge
                                        className="messaging_user_new_badge_position"
                                        pill
                                        color="warning">
                                        New
                                      </Badge>
                                    )}

                                    <div className="grp_member_profile_image cursor-pointer">
                                      {profilePicValidityCheck(
                                        item.profilePic
                                      ) ? (
                                        <div className="list-item__avatar">
                                          <img src={item.profilePic} />
                                        </div>
                                      ) : (
                                        <span
                                          className="list-item__avatar"
                                          data-letters={
                                            item.value == user.profile._id
                                              ? getInitials(user.profile)
                                              : getInitials(item)
                                          }></span>
                                      )}
                                    </div>

                                    <div className="">
                                      <div
                                        className="linkedToolView"
                                        onClick={() => viewMember(item)}>
                                        {item.value == user.profile._id ? (
                                          'You'
                                        ) : (
                                          <span>
                                               {(item.firstName || item.lastName) ? `${item.firstName||""} ${item.lastName||""}`: (item.email || item.mobileNumber) }
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    <Button
                                      onClick={() =>
                                        removeUser(
                                          item.value,
                                          item.mobileNumber
                                        )
                                      }
                                      color="danger"
                                      size="sm"
                                      className="ml-auto mr-3">
                                      <BiTrashAlt size={12} />
                                    </Button>
                                  </div>
                                </LayoutData>
                              )
                            } else {
                              return (
                                <LayoutRow className="ml-0 mr-0">
                                  <LayoutData
                                    colWidth={tableCols.user}
                                    className="bg-white">
                                    {editMode ? (
                                      <div>
                                        <div className="d-flex">
                                          <Input
                                            className="mx-1"
                                            placeholder="First Name"
                                            value={item.firstName}
                                            onChange={(e) => {
                                              handleChangeTableRowData(
                                                itemIndex,
                                                'firstName',
                                                e.target.value
                                              )
                                            }}
                                          />
                                          <Input
                                            className="mx-1"
                                            placeholder="Last Name"
                                            value={item.lastName}
                                            onChange={(e) => {
                                              handleChangeTableRowData(
                                                itemIndex,
                                                'lastName',
                                                e.target.value
                                              )
                                            }}
                                          />{' '}
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          alignItems: 'center',
                                          display: 'flex',
                                        }}
                                        className="my-0 pl-2">
                                        {isNewUser(item) && (
                                          <Badge
                                            className="messaging_user_new_badge_position"
                                            pill
                                            color="warning">
                                            New
                                          </Badge>
                                        )}
                                        <div className="grp_member_profile_image cursor-pointer">
                                          {profilePicValidityCheck(
                                            item.profilePic
                                          ) ? (
                                            <div className="list-item__avatar">
                                              <img src={item.profilePic} />
                                            </div>
                                          ) : (
                                            <span
                                              className="list-item__avatar"
                                              data-letters={
                                                item.value == user.profile._id
                                                  ? getInitials(user.profile)
                                                  : getInitials(item)
                                              }></span>
                                          )}
                                        </div>

                                        <div className="">
                                          <div
                                            className="linkedToolView"
                                            // onClick={() => viewMember(item)}
                                          >
                                            {item.value == user.profile._id ? (
                                              'You'
                                            ) : (
                                              <span>
                                                {' '}
                                                {item.firstName}
                                                {item &&
                                                item.lastName &&
                                                item.lastName.length > 0
                                                  ? `, ${item.lastName}`
                                                  : null}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </LayoutData>

                                  <LayoutData
                                    colWidth={tableCols.phoneNumber}
                                    className="bg-white">
                                    {editMode ? (
                                      <PhoneInputWithCountrySelect
                                        placeholder="Enter phone number"
                                        value={item.mobileNumber}
                                        onChange={(v) => {
                                          handleChangeTableRowData(
                                            itemIndex,
                                            'mobileNumber',
                                            formatPhoneNumber(v)
                                          )
                                        }}
                                        style={{
                                          height: '40px',
                                        }}
                                        defaultCountry="US"
                                      />
                                    ) : (
                                      <span>
                                        {item.mobileNumber &&
                                        item.mobileNumber.length > 0
                                          ? item.mobileNumber
                                          : 'No'}
                                      </span>
                                    )}
                                  </LayoutData>

                                  <LayoutData
                                    colWidth={tableCols.action}
                                    className="bg-white">
                                    <div className="d-flex">
                                      <Button
                                        onClick={() =>
                                          removeUser(
                                            item.value,
                                            item.mobileNumber
                                          )
                                        }
                                        color="danger"
                                        size="sm"
                                        style={{
                                          width: '40px',
                                        }}>
                                        <BiTrashAlt size={12} />
                                      </Button>

                                      {editingIndex === itemIndex ? (
                                        <Button
                                          color="success"
                                          size="sm"
                                          style={{
                                            width: '40px',
                                          }}
                                          className="ml-2"
                                          onClick={() => setEditingIndex(null)}>
                                          <BsCheck2Circle />
                                        </Button>
                                      ) : showEditBtn ? (
                                        <Button
                                          color="warning"
                                          size="sm"
                                          style={{
                                            width: '40px',
                                          }}
                                          className="ml-2"
                                          onClick={() =>
                                            setEditingIndex(itemIndex)
                                          }>
                                          <BiEditAlt />
                                        </Button>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </LayoutData>
                                </LayoutRow>
                              )
                            }
                          })
                        : ''}
                    </div>

                    {!usersLodaing ? (
                      <Row className="mr-0 px-0">
                        <ActionLayoutData
                          noDefault
                          className="col-pl-0 bg-white"
                          colWidth={12}>
                          {options.length > 0 ? (
                            <Select
                              name="user-select"
                              placeholder={
                                'Start typing users name to add new...'
                              }
                              isOpen={true}
                              options={usersList.filter(
                                (x) =>
                                  !sharedWithUsers.some(
                                    (y) => y.value == x.value
                                  )
                              )}
                              onChange={(itm) => onUserSelect(itm)}
                              onInputChange={handleInputChange}
                              className={`trivia-user-share-select-row ${
                                isMobile ? '' : 'py-2'
                              }`}
                              classNamePrefix="select"
                              open={true}
                            />
                          ) : (
                            <LayoutRow className="ml-0 mr-0 no-borders-input-row">
                              <LayoutData
                                noDefault
                                className="col-pl-0 bg-white"
                                colWidth={6}>
                                <div className="d-flex align-items-center">
                                  <Input
                                    autoFocus
                                    value={newUser.name}
                                    ref={innerRef}
                                    placeholder="Start typing users name to add new..."
                                    onChange={(e) => {
                                      handleNewUserRowChange(
                                        e.target.value,
                                        'name',
                                        0
                                      )
                                    }}
                                  />
                                  {isNewUser(newUser) ? (
                                    <Badge pill color="warning">
                                      New
                                    </Badge>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </LayoutData>

                              <LayoutData
                                noDefault
                                className="col-pl-0 bg-white py-0"
                                colWidth={4}>
                                <PhoneInputWithCountrySelect
                                  ref={innerRef2}
                                  placeholder="Enter phone number"
                                  value={newUser.mobileNumber}
                                  onChange={(v) => {
                                    handleNewUserRowChange(
                                      formatPhoneNumber(v),
                                      'mobileNumber',
                                      0
                                    )
                                  }}
                                  style={{
                                    height: '40px',
                                  }}
                                  defaultCountry="US"
                                />
                              </LayoutData>

                              <LayoutData
                                noDefault
                                className="col-pl-0 bg-white"
                                colWidth={2}>
                                <div className="d-flex">
                                  <Button
                                    onClick={() => addNewRowUserToShareTable(0)}
                                    className="mx-1 px-2"
                                    color="success"
                                    style={{ width: '35px' }}
                                    disabled={!newUser.mobileNumber}>
                                    <BiPlusCircle size={20} />
                                  </Button>
                                  <Button
                                    onClick={() => revertOptions()}
                                    className="mx-1 px-2"
                                    color="danger"
                                    style={{ width: '35px' }}>
                                    <BiXCircle size={20} />
                                  </Button>
                                </div>
                              </LayoutData>
                            </LayoutRow>
                          )}
                        </ActionLayoutData>
                      </Row>
                    ) : (
                      <div className="text-center">Loading...</div>
                    )}
                  </div>
                </div>
              </Col>
            </FormGroup>
          </div>
        </div>
      </div>

      <div className="my-3">
        {!uploadCsvUiOpen ? (
          <div>
            <label
              htmlFor="profile-pic-file-input"
              style={{ marginBottom: '0px' }}
              className="btn upload_user_csv_btn_color">
              <IoCloudUploadOutline /> Upload user csv
            </label>
            <input
              id="profile-pic-file-input"
              onChange={handleFileUpload}
              type="file"
            />

            <span className="msg_user_upload_step_3">
              {' '}
              (Only .csv files, maximum 20MB file size)
            </span>
          </div>
        ) : (
          <div className="card p-3 msg_user_upload">
            <div className="message_csv_close_btn_div_position">
              <Button
                onClick={() => {
                  setUploadCsvUiOpen(false)
                  setRowData([])
                  setStep(1)
                }}>
                {' '}
                <BiXCircle /> Close
              </Button>
            </div>
            {step === 1 ? (
              <MapColumnStep
                rowData={rowData}
                setRowData={setRowData}
                gotToNextStep={(users, invalidUsers) => {
                  setTriviaShareAndPrivacy({
                    ...triviaShareAndPrivacy,
                    sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber(
                      [...triviaShareAndPrivacy.sharedWithUsers, ...users]
                    ),
                  })
                  setInvalidUsersList(invalidUsers)
                  setStep(2)
                }}
              />
            ) : (
              <div className="msg_user_upload_step_3">
                <div className="my-2">
                  {invalidUsersList && invalidUsersList.length > 0 ? (
                    <div>
                      <div className="my-2">
                        <span
                          className="text-success"
                          style={{ fontWeight: 500 }}>
                          Success!
                        </span>
                      </div>
                      <div>
                        Users added from csv {invalidUsersList.length} rows
                        skipped{' '}
                        <b
                          onClick={() => setShowInvalidUsers(true)}
                          className="cursor-pointer">
                          view here
                        </b>
                      </div>

                      {showInvalidUsers && (
                        <div>
                          <Table>
                            <thead>
                              <tr>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Mobile Number</th>
                                <th>Email</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invalidUsersList.map((iv) => {
                                return (
                                  <tr>
                                    <td>{iv.firstName}</td>
                                    <td>{iv.lastName}</td>
                                    <td>{iv.mobileNumber}</td>
                                    <td>{iv.email}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>{' '}
                To add more users,{' '}
                <b
                  className="cursor-pointer"
                  onClick={() => {
                    setStep(0)
                    setRowData([])
                    setFile(null)
                    // setTriviaShareAndPrivacy({
                    //   ...triviaShareAndPrivacy,
                    //   sharedWithUsers: [],
                    // });
                  }}>
                  click here
                </b>{' '}
                <span className="link-text cursor-pointer">
                  {' '}
                  Save user upload as a group? click here{' '}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
